<template>
  <v-dialog
    v-model="opened"
    transition="dialog-bottom-transition"
    hide-overlay
    fullscreen
    persistent
  >
    <v-card tile>
      <v-card-title class="modal__title px-4 pt-4 pb-4">
        <span>
          Atualizar Host
        </span>
        <v-spacer />
        <v-btn @click="closeModal" color="primary" icon>
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5 white text-body-1">
        <div class="mw-700 py-5 mx-auto">
          <v-tabs v-model="currentTab" color="realEstate" grow>
            <v-tab v-for="tab in tabs" :key="tab.value">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-divider />
        </div>

        <v-tabs-items v-model="currentTab">
          <v-tab-item key="info">
            <HostUpdate ref="hostUpdate" :closeModal="closeModal" :loading="hostLoading" />
          </v-tab-item>
          <v-tab-item key="history">
            <HostHistory :host-id="host.id" />
          </v-tab-item>
          <v-tab-item key="serviceHistory">
            <HostServiceHistory />
          </v-tab-item>
          <v-tab-item key="accessControl">
            <HostAccessControl
              @updateHostStatus="updateHostStatus"
              :host-id="host.id"
              ref="hostAccessControl"
            />
          </v-tab-item>
          <v-tab-item key="realEstateBlacklist">
            <HostRealEstateBlacklist :host-id="host.id" />
          </v-tab-item>
          <v-tab-item key="singlePayment">
            <HostSinglePayment :host-id="host.id" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import HTextInput from '@/components/app/HTextInput'
import HCheckbox from '@/components/app/HCheckbox'
import HAutocomplete from '@/components/app/HAutocomplete'
import HostServiceTypeSelect from '@/components/host/HostServiceTypeSelect'
import HostSinglePayment from './HostSinglePayment'
import HostUpdate from '@/components/host/HostUpdate'
import HostAccessControl from '@/components/host/HostAccessControl'
import HostServiceHistory from '@/components/host/HostServiceHistory'
import HostHistory from './HostHistory.vue'
import HostRealEstateBlacklist from '@/components/host/HostRealEstateBlacklist'

import { catalogPhone } from '@/util/catalog'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HostUpdateModal',

  components: {
    HostServiceTypeSelect,
    HTextInput,
    HCheckbox,
    HAutocomplete,
    HostUpdate,
    HostAccessControl,
    HostSinglePayment,
    HostServiceHistory,
    HostHistory,
    HostRealEstateBlacklist,
  },

  data() {
    return {
      opened: false,
      currentTab: '',
      hostLoading: false,
    }
  },

  watch: {
    opened(status) {
      if (!status) {
       this.currentTab = 'info'
      }
    },
  },

  computed: {
    ...mapGetters(['host', 'cities', 'isLoading']),

    hasServiceTypeSelected() {
      return this.host.service_type.length > 0
    },

    tabs() {
      return [
        {
          value: 'info',
          title: this.$t('host.modalUpdate.tabs.info'),
        },
        {
          value: 'history',
          title: this.$t('host.modalUpdate.tabs.history'),
        },
        {
          value: 'serviceHistory',
          title: this.$t('host.modalUpdate.tabs.serviceHistory'),
        },
        {
          value: 'accessControl',
          title: this.$t('host.modalUpdate.tabs.accessControl'),
        },
        {
          value: 'realEstateBlacklist',
          title: this.$t('host.modalUpdate.tabs.realEstateBlacklist'),
        },
        {
          value: 'singlePayment',
          title: this.$t('host.modalUpdate.tabs.singlePayment'),
        },
      ]
    },
  },

  methods: {
    ...mapMutations(['setHost']),
    ...mapActions([
      'fetchHost',
      'fetchEnabledCitiesAdmin',
      'fetchHostAccessControlHistory',
    ]),

    formatPhone: catalogPhone,

    openModal(hostId) {
      Promise.resolve(this.setHost({}))
        .then(() => {
          this.opened = true
          this.hostLoading = true
          this.fetchHost(hostId).finally(() => this.hostLoading = false)
          this.fetchHostAccessControlHistory(hostId)
        })
    },

    resetForm() {
      this.$refs.hostUpdate.$refs.hostForm.reset()
    },

    updateHostStatus(status) {
      const hostUpdate = this.$refs.hostUpdate
      hostUpdate.host.enabled = status

      // passing true to do not close modal...
      this.$nextTick(() => hostUpdate.update(true))
    },

    closeModal() {
      // this.resetForm()
      this.opened = false
    },
  },
}
</script>
